import { ActivatedRouteSnapshot } from '@angular/router';

export function getAllPathParams(route: ActivatedRouteSnapshot): Record<string, string> {
  let params = { ...route.params };

  let parent = route.parent;
  while (parent) {
    params = { ...parent.params, ...params };
    parent = parent.parent;
  }

  return params;
}
